<template>
  <div id="app">

    <header>
      <h1>Die Euroländer</h1>
    </header>

    <div class="container">

      <div class="action-select" :class="[ready ? 'is-visible' : 'is-hidden']">
        <p>Was möchten Sie tun?</p>
        <RadioButton id="Länderporträt anschauen" name="grp" action="showView" value="portrait" checked="checked"></RadioButton>
        <RadioButton id="Länder nach Kennzahlen vergleichen" name="grp" action="showView" value="comparison"></RadioButton>  
      </div>

      <div class="flex content" :class="[ready ? 'is-visible' : 'is-hidden']">
        <div class="widget" :class="[infoView === 'portrait' ? 'extra-margin' : '']">
          <div class="inner">
            <div class="wrapper map" >
              <Map :countries="countries" :selectedCountry="selectedCountry" :view="infoView"></Map>
            </div>
            <div class="wrapper filter" >
                <ul class="list" :class="[infoView === 'portrait' ? 'hide-s' : '']">
                  <li v-for="(item, index) in filter" :key="item.id">
                    <RadioButton 
                      v-bind:id="item.label" 
                      v-bind:isDisabled="filterDisabled"
                      action="setFilter"
                      v-bind:value="index"
                      name="grp-type">
                    </RadioButton>
                  </li>
                  <li>
                    <CheckBox id="Alle Länder auswählen" name="grp-all" class="hide-s"
                      v-bind:isDisabled="filterDisabled"
                      v-bind:checked="allCountriesSelected"
                      action="selectAllCountries">
                    </CheckBox>
                  </li>
                </ul>
              </div>
            </div>
        </div>
        <div class="widget">
          <div class="wrapper info">
            <Info :selectedCountry="selectedCountry" :all="countries" :countries="selectedCountries" :view="infoView" :filter="filter" :curFilter="curFilter" :columns="columns"></Info>
          </div>
        </div>
      </div>
  </div>

  <footer class="wrapper">
    <div class="container">
      <!-- <a href="./downloads/eurolaender_jhs.pdf" target="_blank">DOWNLOAD</a> -->
      <a href="#impressum">IMPRESSUM</a>
      <div class="icon-logo">&nbsp;</div>
    </div>
  </footer>

  <Overlays></Overlays>

  </div>

</template>



<script>

  let d3 = require ('d3')

  export default 
  {
    name: 'app',
    components: {
      CheckBox : require ('./components/check-box/CheckBox.vue'),
      Info: require ('./components/info/Info.vue'), 
      RadioButton : require ('./components/radio-button/RadioButton.vue'),
      Map: require ('./components/map/Map.vue'),
      Overlays: require ('./components/overlays/Overlays.vue')
    },
    created: function() {
      this.loadData()
    },
    mounted : function() 
    {
      EventBus.$on('action', function(data) {

        switch (data.action) {

          case 'showView': 
            this.resetCountries();
            this.infoView = data.value
            this.allCountriesSelected = false;

            if (data.value === 'portrait') {

              // console.log(d3.selectAll('.euro-land'))
              d3.selectAll('.euro-land.is-active').classed('is-active', false)
              d3.select('.cId-' + this.selectedCountry.ID).classed("is-active", true)
              this.filterDisabled = true

              // todo: extra function setcountry
              this.selectedCountry = this.countries[1]
              this.countries.forEach(function(el) {
                if (el.ID === 'de') el.isactive = true
              })

              // d3.selectAll('.euro-land').classed("is-active", false)
              // d3.select('.cId-' + this.selectedCountry.ID).classed("is-active", true)
            }

            else {
              d3.select('.cId-' + this.selectedCountry.ID).classed("is-active", false)
              this.filterDisabled = false
              this.curFilter = ''
              this.selectedCountries = []

            }
            break

          case 'setFilter':
            this.curFilter = this.filter[data.value]
            break; 

          case 'selectAllCountries': 
            if (this.allCountriesSelected) 
            {
              this.resetCountries();
              this.selectedCountries = []
              d3.selectAll('.euro-land.is-active').classed('is-active', false)
            }
            else {
              this.selectedCountries = []
              this.countries.forEach(function(el) {
                el.isactive = true;
                this.selectedCountries.push(el)
                d3.selectAll('.cId-' + el.ID).classed('is-active', true)
              }.bind(this))
            }
            this.allCountriesSelected = !this.allCountriesSelected
            break;
          default: 
            break

        }

      }.bind(this));


      EventBus.$on('loaded', function(file) {

        this.dataToLoaded++
        if (this.dataToLoaded === 2)
          this.init()

      }.bind(this));



      EventBus.$on('setCountry', function(index) {

        if (this.infoView === 'portrait') 
        {
          // set default country
          if (this.selectedCountry.length === 0) 
          {
            this.selectedCountry = this.countries[index]
          }
          else 
          {
            this.countries[this.selectedCountry.index].isactive = false 
            this.selectedCountry = this.countries[index];
          }
          this.countries[index].isactive = true
          // update map
          d3.selectAll('.euro-land.is-active').classed("is-active", false)
          d3.select('.cId-' + this.selectedCountry.ID).classed("is-active", true)
        }
        else if (this.infoView === 'comparison') 
        {
          // toggle active flag
          this.countries[index].isactive = !this.countries[index].isactive

          let el = d3.select('.cId-' + this.countries[index].ID)

          el.classed("is-active", !el.classed("is-active"))



          // add country
          if (this.countries[index].isactive) {
            this.selectedCountries.push(this.countries[index]);
          }
          // remove country
          else {
            let removeID
            this.selectedCountries.forEach(function(el, i) {
              if (el.ID === this.countries[index].ID)
                removeID = i
            }.bind(this))
            this.selectedCountries.splice(removeID, 1)
            this.allCountriesSelected = false
          }

        }

      }.bind(this))

    },


    methods: 
    {

      resetCountries: function() 
      {
        this.countries.forEach(function(cD) {
          cD.isactive = false;
        })
      },

      /**
        init function after data loaded
      */
      init: function() 
      {
        // set default country
        let countryIndex = 1  // countries[i] => DEUTSCHLAND
        EventBus.$emit('action', {action: 'showView', value: 'portrait'})
        EventBus.$emit('setCountry', countryIndex)

        this.ready = true;

      },

      /**
        load csv with countries and values
      */
      loadData: function() 
      {
          d3.csv(this.CSV, function(data) {

            // set max filter values
            this.filter.forEach(function(filter, index) {
              let max = 0, min = 0

              data.forEach(function(c, i) {
                max = ( parseFloat(c[data.columns[filter.value]]) > parseFloat( max) ) 
                  ? parseFloat(c[data.columns[filter.value]]) 
                  : parseFloat(max)

                min = ( parseFloat(c[data.columns[filter.value]]) < parseFloat( min) ) 
                  ? parseFloat(c[data.columns[filter.value]]) 
                  : parseFloat(min)

              }.bind(this))

              this.filter[index].max = max
              this.filter[index].min = min

            }.bind(this))

            data.forEach(function(el, index) {
              el.isactive = false
              el.index = index
            }.bind(this))

            // save values and columns
            this.countries = data
            this.columns = data.columns

            // this.init()
            
            EventBus.$emit('loaded', 'csv')


          }.bind(this));
      }

    },


    data: function() {
      return {
        countries: [],
        selectedCountry: [],
        selectedCountries: [],
        filterDisabled: true,
        curFilter: '',
        // countries: [],
        infoView: 'portait',
        allCountriesSelected: false,
        filter: [
          {'label': 'Bruttoinlandsprodukt', 'value': '4', 'cl': 'icon-bip', 'unit': '€', 'max': 0 },
          {'label': 'Arbeitslosenquote', 'value': '7', 'cl' : 'icon-people', 'unit': '%', 'max': 0 },
          {'label': 'Staatsverschuldung', 'value': '6', 'cl' : 'icon-debt', 'unit': '%', 'max': 0 },
          {'label': 'Haushaltssaldo', 'value': '5', 'cl' : 'icon-budget', 'unit': '%', 'max': 0 },
          {'label': 'Lohnstückkostenniveau', 'value': '8', 'cl' : 'icon-sold', 'unit': '', 'max': 0 }
        ],
        columns: [],
        CSV: 'data/europe_data.csv',
        dataToLoaded: 0,
        ready: false
      }

    }
  }

</script>



<style lang="scss">

  .action-select, .content {
    transition: opacity .5s;
  }

  .content {
    @include breakpoint(s) {
      background-color: #fff;
      padding: 10px;
    }
    @include breakpoint(s) {
      padding: 15px;
    }
  }

  .is-hidden {
    opacity: 0;
    transition: opacity .5s;
  }

  .is-visible {
    opacity: 1;
  }

  .wrapper {
    background-color: #fff;
  }

  .action-select {
    margin-bottom: 20px;

    p {
      @include font-milo-m(1.5em);
    }

    .radiobutton {
      margin-left: 15px;
      font-size: 1.25em;

      @include breakpoint(xs, max) {
        margin-left: 10px;
      }

    }

    // @include breakpoint(m) {
      // margin: 0;
      // clear: both;

      // &:after {
      //   content: "";
      //   display: table;
      //   clear: both;
      // }

      // .radiobutton, p {
      //   float: left;
      // }

      // .radiobutton {
      //   margin-top:  25px;
      //   margin-left: 60px;
      // }
    // }

    
  }


  .filter {
    margin:0;
    padding-bottom: 0;
    position: relative;

    @include breakpoint(s) {
    }

    .list {
      list-style: none;
      columns: 2;
      margin: 20px;
      padding: 20px 0 10px 0;

      @include breakpoint(xs, max) {
        columns: 1;
        margin: 10px;
        padding: 10px 0 0px 0;
      }


      @include breakpoint(s) {
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 0 0 0 10px;
        margin: 0 0 -10px 0;
        columns: 1;
      }

      @include breakpoint(m) {
        position: relative;
        padding: 20px 0 10px 0;
        margin: 0 0 0 10px;
        columns: 2;
      }
    }

    .radiobutton, .checkbox {
      // padding: 2px 0;
      margin: 0 0 10px 0;

      label {
        padding-left: 8px;
      }
    }
  }

  footer {
      margin-top: 20px;

      .container {
        @extend .clear;
      }

      .container > * {
      display: inline-block;
      margin: 15px 0;
      padding: 30px 0 0 0;
      float: right;


      // &:first-child {
      //   float: none;
      // }
    }

    a:hover {
        text-decoration: underline;
      }

  .icon-logo {
        width: 110px;
        background-size: 100px;
        background-position: left top;
      }

  } 

</style>




// WEBPACK FOOTER //
// App.vue?653604ee